import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useRef } from 'react';
import useIntersection from '../../hooks/useIntersection';
import s from './IntersectionWrapper.module.scss';

const IntersectionWrapper = ({ children, className }) => {
  const blockRef = useRef(null);
  const entry = useIntersection(blockRef, {
    threshold: 0,
    root: null,
    rootMargin: '0px',
  });
  return (
    <div ref={blockRef} className={classNames(s.contentBlock, { [s.visible]: !!entry }, className)}>
      {children}
    </div>
  );
};
IntersectionWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default IntersectionWrapper;
